import BUILDER_ESTIMATOR_ROUTE_NAME from "@/constants/builderEstimatorRouteName";
import { RouteLocationNormalized } from "vue-router";
import { CUSTOM_SUBDOMAINS_HOSTNAME } from "@/constants/customSubdomains";

type HandleCustomSubdomainRedirectResult = {
  name: string;
  params?: Record<string, string>;
};

const handleCustomSubdomainRedirect = (
  to: RouteLocationNormalized
): HandleCustomSubdomainRedirectResult | null => {
  const BUILDER_ID = process.env.VUE_APP_SHAPEHOMES_SUBDOMAIN_BUILDER_ID;

  const isCustomSubdomain = CUSTOM_SUBDOMAINS_HOSTNAME.includes(
    window.location.hostname
  );

  if (!isCustomSubdomain) return null;

  const isBuilderEstimatorRoute = to.name === BUILDER_ESTIMATOR_ROUTE_NAME;
  const isBuilderIdMatch = to.params.builderId === BUILDER_ID;

  if (!isBuilderEstimatorRoute || !isBuilderIdMatch) {
    return {
      name: BUILDER_ESTIMATOR_ROUTE_NAME,
      params: { builderId: BUILDER_ID },
    };
  }

  return null;
};

export default handleCustomSubdomainRedirect;
